var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUncheckedRound(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.903 0c6.507 0 11.801 5.384 11.801 12s-5.294 12-11.8 12C5.396 24 .101 18.616.101 12S5.397 0 11.903 0zm5.514 6.387a.992.992 0 0 0-1.402-.012l-4.161 4.16-4.16-4.16-.086-.076a.994.994 0 0 0-1.317.088.992.992 0 0 0-.012 1.402l4.16 4.16-4.16 4.161-.076.086a.994.994 0 0 0 .088 1.317.992.992 0 0 0 1.402.012l4.16-4.161 4.162 4.16.085.077a.994.994 0 0 0 1.317-.088.992.992 0 0 0 .012-1.403l-4.161-4.161 4.16-4.16.077-.086a.994.994 0 0 0-.088-1.316z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheckedRound);
export default __webpack_public_path__ + "static/media/unchecked-round.a5cf6fe33afc0ee4c2a72059efb8dcdf.svg";
export { ForwardRef as ReactComponent };